<template>
    <select
        @change="e => $emit('input', e.target.value)"
        class="form-control"
        :name="name"
        :value="value"
    >
        <option
            disabled
            selected
            value=""
            v-if="value === null || !value.length"
        >
            -- Select --
        </option>
        <option
            :key="option.id"
            :selected="value === option.id || value === Number(option.id)"
            :value="option.id"
            v-for="option in options"
            v-text="option.label"
        ></option>
    </select>
</template>

<script>
import _ from "lodash";

export default {
    name: 'EntitySelectMenu',

    props: {
        entityType: {
            required: true,
            type: String,
        },
        finders: {
            default: () => ({}),
            required: false,
            type: Object,
        },
        name: {
            default: 'entity-select-input',
            required: false,
            type: String,
        },
        value: {
            required: true,
        },
    },

    data() {
        return {
            options: {},
        }
    },

    methods: {
        getOptions() {
            axios
                .get(`/api/v0/${this.entityType}/list`, {
                    headers: {token: this.$root.state.loggedInUser.api_token},
                    params: {finders: this.finders},
                })
                .then(res => {
                    if (_.isEmpty(res.data.data)) {
                        this.$emit('empty');

                        return;
                    }

                    let options = Object.entries(res.data.data)
                        .map(entry => {
                            return {id: entry[0], label: entry[1]};
                        })
                        .sort((entityA, entityB) => {
                            let labelA = entityA.label.toLowerCase().replace(' ', ''),
                                labelB = entityB.label.toLowerCase().replace(' ', '');

                            if (labelA > labelB) return 1;
                            if (labelB > labelA) return -1;
                            return 0;
                        });
                    Object.assign(this, {options});
                })
                .catch(err => console.error(err));
        },
    },

    created() {
        this.getOptions();
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Forms/InputFields/EntitySelectInput.vue